module.exports = __webpack_public_path__ + "static/media/10_light.98403401.svg";